<div id="main" [ngClass]="sidebarExpanded ? 'open' : 'open2' ">
  <!-- <app-navbar></app-navbar> -->
  <nav class="navbar navbar-expand-lg navbar-light navbar-main admin w-100">
    <!-- Use any element to open the sidenav -->
    <div class="row mx-0 w-100">
        <div class="col-2 col-lg-1 order-3 order-lg-1 pl-lg-5">
            <button class="navbar-toggle mr-2 border-0 bg-none blue pl-0 pr-1 d-flex d-xl-none justify-content-center align-items-center" [ngClass]="sidebarExpanded ? 'hide-button' : 'show-button' " type="button" id="btn-opn-left-menu" (click)="buttonOpenAndClose()" style="min-height: 40px;">
                <i class="icon-menu_hamb font-size-24"></i>
            </button>
        </div>
        <div class="col-6 col-lg-7 order-1 order-lg-2 d-flex align-items-start px-0">

            <div class="ml-2 text-white d-flex aling-items-center justify-content-center d-lg-none">
                <img src="/assets/img/logo-admin.svg" class="img-responsive" >
                <div class="ml-2 pt-2">
                    <p class="font-size-16 line-height-100 m-0">{{'Eficacia' | translate }}</p>
                    <p class="font-size-12 m-0">{{'DIY SaaS' | translate }} </p>
                </div>
            </div>
            <div class="row mx-0 d-none d-lg-flex justify-content-center align-items-center">
                <p class="blue-0041A3 font-solomon-semibold font-size-14 w-100 mb-0"><span class="font-size-18 mr-2"><i class="icon-arrow_left font-size-12"></i></span>{{ 'Regresar a la sección previa' | translate }}</p>
              <p class="blue-dark font-solomon font-size-12 breadcrumb-header w-100 mb-0"><a class="link-blue-dark" routerLink="/">{{ 'Inicio' | translate }}</a> <span *ngIf="TextParent !== ''"> > </span> <a *ngIf="TextParent !== ''" class="link-blue-dark" routerLink="{{LinkParent}}"> {{TextParent}}</a> <span *ngIf="TextActual !== ''"> > </span> <span *ngIf="TextActual !== ''" class="actual green-3BD4AE">{{TextActual}} </span></p>
              </div>
        </div>
        <div class="col-4 order-2 order-lg-3 pr-0">
            <!-- <img src="/assets/img/user-octagon.png"  class="ml-3 img-responsive header-avatar float-right d-block d-lg-none"> -->
            <div class="align-items-center justify-content-end d-none d-lg-flex">

                <div class="header-search mr-5 pr-4 d-flex justify-content-center align-items-center">
                    <i class="icon-search font-size-18 gray-C4C7CE mr-4"></i> <i class="icon-notification gray-C4C7CE font-size-20 mr-2"></i>
                </div>
                <div ngbDropdown class="d-inline-block text-right" *ngIf="user?.user_type == userType.DoItYourself || user?.user_type == userType.Merchandising">
                  <button type="button" class="btn btn-no font-size-14 font-solomon-semibold mb-0 p-0 d-block" id="dropdownBasic1" ngbDropdownToggle>{{user?.first_name}} {{user?.last_name}}</button>
                  <span class="font-solomon font-size-12" *ngIf="user?.connectedToOrg">{{ 'Conectado a:' | translate }} <b class="font-solomon-bold blue-dark">{{user?.connectedToOrg.name}}</b></span>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="openConnectedOrgModal()" *ngIf="user?.user_type == userType.DoItYourself ">{{ 'Cambiar Cliente' | translate }}</button>
                    <button ngbDropdownItem (click)="openConnectedOrgModal()" *ngIf="user?.user_type == userType.Merchandising">{{ 'Cambiar a Merchandising' | translate }}</button>
                    <button ngbDropdownItem (click)="cancelConnectOrg()" *ngIf="user?.connectedToOrg">{{ 'Salir del cliente' | translate }}</button>
                  </div>
                </div>
                <p class="font-size-14 font-solomon-semibold mb-0" *ngIf="user?.user_type == userType.User">{{user?.first_name}} {{user?.last_name}}</p>
                <img src="/assets/img/user-octagon.png"  class="ml-3 img-responsive header-avatar">

            </div>
        </div>
    </div>



    <button class="navbar-toggler mr-3 d-none" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse bg-white" id="navbarNavDropdown">


    </div>
  </nav>
<div *ngIf="exportRequests.length" class="export-status-banner-layout">
  <div *ngFor="let exportRequest of exportRequests" class="export-status-banner-item">
    <div class="export-status-copy">
      <div class="export-status-line">
        <span class="export-status-text">
          Descarga de {{ exportRequest.label }}
        </span>
        <span class="export-status-message" [ngClass]="{
          'is-processing': exportRequest.status === 'processing',
          'is-success': exportRequest.status === 'success',
          'is-error': exportRequest.status === 'error'
        }">
          {{ exportRequest.message }}
        </span>

        <div *ngIf="exportRequest.status === 'processing'" class="export-status-progress" aria-hidden="true">
          <span class="export-status-progress-bar"></span>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="export-status-close"
      aria-label="Cerrar"
      (click)="dismissExportRequest(exportRequest.id)"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</div>
  <!-- <app-menu-left></app-menu-left> -->
  <div id="mySidenav" [ngClass]="sidebarExpanded ? 'open sidenav' : 'open2 sidenav' ">
    <div class="row mx-0 pb-3 mb-3" style="border-bottom: 1px solid white;">
      <div class="col-9 d-flex align-items-start">
        <img src="/assets/img/logo-admin.svg" class="img-responsive" >
        <div class="ml-2 text-white pt-1">
          <p class="font-size-16 m-0">{{ 'Eficacia' | translate }}</p>
          <p class="font-size-12 m-0">{{ 'DIY SaaS' | translate }}</p>
        </div>

      </div>
      <div class="col-3">
        <a href="javascript:void(0)" class="closebtn font-size-24" (click)="buttonOpenAndClose()"> <i class="icon-arrow_left"></i> </a>
      </div>
    </div>
    <div class="row mx-0 pb-3 mb-3" style="border-bottom: 1px solid white;">
      <div class="col-8 pr-0">
          <input type="text" class="form-control rounded-8 font-size-12" placeholder="{{ '¿Qué quieres buscar?' | translate }}">
      </div>
      <div class="col-4 ">
          <button class="btn-search-icon">
              <i class="icon-search_normal text-white font-size-20"></i>
          </button>
      </div>
    </div>
    <div class="row mx-0 pb-2 mb-3" style="border-bottom: 1px solid white;">
      <ul class="list-menu">
        <li>
          <a class="font-solomon font-size-18 text-white  font-solomon-bold" href="" >
            <i class="icon-house"></i>
                      {{ 'Inicio' | translate }}
          </a>
        </li>
        <!-- <li >

          <a class="font-solomon font-size-18 text-white  font-solomon-bold" [routerLink]="['/notifications']">
            <i class="icon-notification"></i>
                      Notificaciones
          </a>
        </li> -->
        <li *ngIf="user?.can_access_services">
          <a class="font-solomon font-size-18 text-white  font-solomon-bold" [routerLink]="['/services']">
            <i class="icon-box"></i>
            {{ 'Servicios' | translate }}
          </a>
        </li>
        <li *hasPermission="'W-REP.GESTION_REPORTES'; action:'CONSULT'">
          <a class="font-solomon font-size-18 text-white font-solomon-bold" [routerLink]="['/settings/reports']">
            <i class="icon-status-up"></i>
                      {{ 'Reportes' | translate }}
          </a>
        </li>
        <li *hasPermission="'W-ACTIVIDADES'">
          <a class="font-solomon font-size-18 text-white font-solomon-bold" [routerLink]="['/activities']">
            <i class="icon-box"></i>
            {{ 'Actividades' | translate }}
          </a>
        </li>
        <!-- B8 (auditoría roles-sprint-2, ciclo 2): el <li> se mostraba por
          permiso, pero los <a> internos dependen ADEMÁS de ms_access
          (hasAccessMarketing/hasAccessSales) — un usuario con el permiso
          pero sin ninguno de los dos accesos veía un ítem de menú vacío.
          Se combinan ambas condiciones en el mismo <li>. -->
        <li *hasPermission="'W-PAR.SEGUIMIENTO_RUTAS'" [hidden]="!hasAccessMarketing && !hasAccessSales">
          <a class="font-solomon font-size-18 text-white font-solomon-bold" *ngIf="hasAccessMarketing" [routerLink]="['/tracking-routes/marketing']">
            <i class="icon-map"></i>
            {{ 'Seguimiento de rutas' | translate }}
          </a>
          <a class="font-solomon font-size-18 text-white font-solomon-bold" *ngIf="hasAccessSales && !hasAccessMarketing" [routerLink]="['/tracking-routes/sales']">
            <i class="icon-map"></i>
            {{ 'Seguimiento de rutas' | translate }}
          </a>
        </li>
        <li>
          <a class="font-solomon font-size-18 text-white" [routerLink]="['/memberships/membership']" *ngIf="is_administrator">
            <i class="icon-settings"></i>
            {{ 'Membresías' | translate }}
          </a>
        </li>
        <li *ngIf="is_administrator">
          <a class="font-solomon font-size-18 text-white" [routerLink]="['/settings/panel']">
            <i class="icon-settings"></i>
                      {{ 'Parametrización' | translate }}
          </a>
        </li>
        <ng-container *ngIf="!is_administrator">
          <li *hasPermission="'W-PARAMETRIZACION'">
            <a class="font-solomon font-size-18 text-white" [routerLink]="['/settings/shortcuts']">
              <i class="icon-settings"></i>
                        {{ 'Parametrización' | translate }}
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="row mx-0 pb-2 mb-3" style="border-bottom: 1px solid white;">
      <p class="subtitle-menu font-solomon-bold font-size-18 text-white mb-0">{{ 'Accesos rápidos' | translate }}</p>
      <ul  class="list-menu">
        <li *hasPermission="'W-ACT.MOMENTOS'">
          <a class="font-solomon font-size-18 text-white  font-solomon-bold" [routerLink]="['/moments/']">
            <i class="icon-star"></i>
                      Momentos
          </a>
        </li>
        <li *hasPermission="'W-ACT.FORMULARIOS'">
          <a class="font-solomon font-size-18 text-white font-solomon-bold" [routerLink]="['/activities/forms/list']">
            <i class="icon-star"></i>
                      {{ 'Formularios' | translate }}
          </a>
        </li>
        <li *hasPermission="'W-ACT.DINAMICAS_COMERCIALES'; action:'CONSULT'">
          <a class="font-solomon font-size-18 text-white font-solomon-bold" [routerLink]="['/business-dynamics/available-dynamics/list']">
            <i class="icon-star"></i>
                      {{ 'Dinamicas comerciales' | translate }}
          </a>
        </li>
        <li *hasPermission="'W-ACT.AUTOGESTION_RUTAS'">
          <a class="font-solomon font-size-18 text-white font-solomon-bold" [routerLink]="['/activities/routes-management']">
            <i class="icon-star"></i>
                      {{ 'Autogestión de rutas' | translate }}
          </a>
        </li>
      </ul>
    </div>


    <div class="mt-auto">
      <div class="row mx-0 pb-2 " style="">
        <ul class="list-menu mb-0 mt-3 mb-2">
          <li>
            <a class="font-solomon font-size-18 text-white" (click)="logout()">
              <i class="icon-logout"></i>
                          {{ 'Cerrar sesión' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>


  </div>
    

  <div class="container-fluid my-3 px-4" style="min-height: 83vh;">
    <router-outlet></router-outlet>
  </div>
  <app-footer-admin></app-footer-admin>
</div>
